import React, { useState } from "react";
import TownPlanningSidebar from "../components/TownPlanningSidebar";
import styles from "../styles/TownPlanningDashboard.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { FaArrowLeft, FaSearch, FaDownload, FaFilter, FaCalculator, FaFilePdf } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export default function Feedback() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
const navigate = useNavigate();
  const handleBack = () => {
    navigate("/")
  };
  return (
    <div
      className={styles.homeScreenContainer}
      style={{
        height: "100vh",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Header */}
      <div className={styles.homeScreenHeader}>
        {/* <button
          onClick={() => setIsSidebarOpen(true)}
          className={styles.homeScreenMenuBtn}
        >
          <FontAwesomeIcon icon={faBars} />
        </button> */}

        
        <button className={styles.homeScreenMenuBtn} onClick={handleBack}>
          <FaArrowLeft />
        </button>

        <TownPlanningSidebar
          isOpen={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
        />

        <h2 style={{ color: "white" }}>Feedback</h2>
      </div>

      {/* Scrollable Content Area */}
      <div
        style={{
          flex: 1,
          overflowY: "auto",
          padding: "20px",
          color: "white",
        }}
      ><div
  style={{
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    fontSize: "18px",
  }}
>
  {/* WhatsApp Row */}
  <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
    <FontAwesomeIcon icon={faWhatsapp} size="2x" />
    <span>+91 9922979783</span>
  </div>

  {/* Email Row */}
  <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
    <FontAwesomeIcon icon={faEnvelope} size="2x" />
    <span>sbn.parola@gmail.com</span>
  </div>
</div>

      </div>
    </div>
  );
}
